import {Injectable} from '@angular/core';
import {SecureTable} from '../secure.table';
import {CdoCustomerRequirement} from '../../interfaces/customer-documents/cdo-customer-requirement';
import {db} from '../db.service';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {
  CdoCustomerRequirementFactory
} from '../../factories/customer-documents/cdo-customer-requirement-factory';

@Injectable({
  providedIn: 'root'
})
export class CdoCustomerRequirementsTable extends SecureTable<CdoCustomerRequirement> {

  public constructor() {
    super(db.cdoCustomerRequirements);

    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      adapter: new DefaultAdapter<CdoCustomerRequirement>({
        api: ['cdo-customer-requirements'],
        fromObject: CdoCustomerRequirementFactory.fromObject,
        toRemote: CdoCustomerRequirementFactory.toRemote
      })
    };
  }

  /**
   *
   * @param customerId
   */
  public async getByCustomerId(customerId: number): Promise<CdoCustomerRequirement[]> {
    return this.table.where('customerId').equals(customerId).toArray();
  }

  /**
   * The natural key of a requirement – the server keeps it unique as well.
   *
   * @param customerId
   * @param cdoDocumentTypeId
   */
  public async getByCustomerAndCdoDocumentType(
    customerId: number,
    cdoDocumentTypeId: number
  ): Promise<CdoCustomerRequirement> {
    return this.table.where('[customerId+cdoDocumentTypeId]').equals([customerId, cdoDocumentTypeId]).first();
  }

  /**
   * Drops the already synchronized requirements of the given customers, so the
   * server answer can replace them. Unsynchronized ones stay untouched.
   *
   * @param customerIds
   */
  public async removeSyncedByCustomerIds(customerIds: number[]): Promise<void> {
    const cdoCustomerRequirements = await this.table.where('customerId').anyOf(customerIds).toArray();
    await this.removeMany(cdoCustomerRequirements.map(({ uuid }) => uuid), true);
  }

}
